"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltip = void 0;
var styled_components_1 = __importStar(require("styled-components"));
// Don't show the Tooltip immediately to prevent flicker during correction.
var delayArrival = (0, styled_components_1.keyframes)({
    '0%': {
        opacity: 0,
    },
    '95%': {
        opacity: 0,
    },
    '100%': {
        opacity: 1,
    },
});
exports.StyledTooltip = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, space = _b.space, mediaQueries = _b.mediaQueries, responsiveFontSizes = _b.responsiveFontSizes;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: none;\n    position: absolute;\n    z-index: 3;\n    left: 50%;\n    top: ", ";\n    padding: ", ";\n    max-width: 36rem;\n    pointer-events: none;\n    font-size: ", ";\n\n    ", " {\n      display: block;\n      animation: ", " 0.6s linear forwards;\n      font-size: ", ";\n    }\n  "], ["\n    display: none;\n    position: absolute;\n    z-index: 3;\n    left: 50%;\n    top: ", ";\n    padding: ", ";\n    max-width: 36rem;\n    pointer-events: none;\n    font-size: ", ";\n\n    ", " {\n      display: block;\n      animation: ", " 0.6s linear forwards;\n      font-size: ", ";\n    }\n  "])), space[2], space[1], responsiveFontSizes.small[0], mediaQueries.smallAndUp, delayArrival, responsiveFontSizes.small[1]);
});
var templateObject_1;
